// Step1UserInfo.js
import PropTypes from "prop-types";
import { useState } from "react";

const UserInfo = ({
  values,
  touched,
  errors,
  handleChange,
  handleBlur,
  setFieldValue,
}) => {
  // 1. Add `touched` and `handleBlur` to props
  const [passwordRequirements, setPasswordRequirements] = useState({
    length: false,
    uppercase: false,
    lowercase: false,
    number: false,
    specialChar: false,
  });

  const handlePasswordChange = (password, setFieldValue) => {
    // Validate password against requirements
    setPasswordRequirements({
      length: password.length >= 8,
      uppercase: /[A-Z]/.test(password),
      lowercase: /[a-z]/.test(password),
      number: /\d/.test(password),
      specialChar: /[!@#$%^&*(),.?":{}|<>]/.test(password),
    });

    // Update Formik's state
    setFieldValue("password", password);
  };

  return (
    <div>
      <div className="form-controls">
        <label htmlFor="firstName">
          First Name{" "}
          <span className="required-inputs" aria-label="required">
            *
          </span>
        </label>
        <input
          autoFocus
          type="text"
          id="firstName"
          name="firstName"
          value={values.firstName}
          onChange={handleChange}
          onBlur={handleBlur} // 2. Add `onBlur` handler
          className={touched.firstName && errors.firstName ? "input-error" : ""} // 3. Conditionally apply error class
        />
        {/* 4. Conditionally show error message */}
        {touched.firstName && errors.firstName && (
          <span className="error">{errors.firstName}</span>
        )}
      </div>
      <div className="form-controls">
        <label htmlFor="lastName">
          Last Name{" "}
          <span className="required-inputs" aria-label="required">
            *
          </span>
        </label>
        <input
          type="text"
          id="lastName"
          name="lastName"
          value={values.lastName}
          onChange={handleChange}
          onBlur={handleBlur} // 2. Add `onBlur` handler
          className={touched.lastName && errors.lastName ? "input-error" : ""} // 3. Conditionally apply error class
        />
        {/* 4. Conditionally show error message */}
        {touched.lastName && errors.lastName && (
          <span className="error">{errors.lastName}</span>
        )}
      </div>
      <div className="form-controls">
        <label htmlFor="email">
          Email{" "}
          <span className="required-inputs" aria-label="required">
            *
          </span>
        </label>
        <input
          type="email"
          id="email"
          name="email"
          style={{ textTransform: "lowercase" }}
          autoComplete="off"
          value={values.email}
          onChange={handleChange}
          onBlur={handleBlur} // 2. Add `onBlur` handler
          className={touched.email && errors.email ? "input-error" : ""} // 3. Conditionally apply error class
        />
        {/* 4. Conditionally show error message */}
        {touched.email && errors.email && (
          <span className="error">{errors.email}</span>
        )}
      </div>
      <div className="password-requirements">
        <ul>
          <li className={passwordRequirements.length ? "valid" : "invalid"}>
            Must be at least 8 characters long
          </li>
          <li className={passwordRequirements.uppercase ? "valid" : "invalid"}>
            Must contain an uppercase letter (A-Z)
          </li>
          <li className={passwordRequirements.lowercase ? "valid" : "invalid"}>
            Must contain a lowercase letter (a-z)
          </li>
          <li className={passwordRequirements.number ? "valid" : "invalid"}>
            Must contain a number
          </li>
          <li
            className={passwordRequirements.specialChar ? "valid" : "invalid"}
          >
            Must contain a special character (!, %, @, #, etc.)
          </li>
        </ul>
      </div>
      <div className="form-controls">
        <label htmlFor="password">
          Password{" "}
          <span className="required-inputs" aria-label="required">
            *
          </span>
        </label>
        <input
          type="password"
          id="password"
          name="password"
          value={values.password}
          onChange={(e) => handlePasswordChange(e.target.value, setFieldValue)}
          
          className={touched.password && errors.password ? "input-error" : ""} // 3. Conditionally apply error class
        />
        {/* 4. Conditionally show error message */}
        {touched.password && errors.password && (
          <span className="error">{errors.password}</span>
        )}
      </div>
      <div className="form-controls">
        <label htmlFor="confirmPassword">
          Confirm Password{" "}
          <span className="required-inputs" aria-label="required">
            *
          </span>
        </label>
        <input
          type="password"
          id="confirmPassword"
          name="confirmPassword"
          autoComplete="off"
          value={values.confirmPassword}
          onChange={handleChange}
          onBlur={handleBlur} // 2. Add `onBlur` handler
          className={
            touched.confirmPassword && errors.confirmPassword
              ? "input-error"
              : ""
          } // 3. Conditionally apply error class
        />
        {/* 4. Conditionally show error message */}
        {touched.confirmPassword && errors.confirmPassword && (
          <span className="error">{errors.confirmPassword}</span>
        )}
      </div>
    </div>
  );
};

UserInfo.propTypes = {
  values: PropTypes.shape({
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    password: PropTypes.string.isRequired,
    confirmPassword: PropTypes.string.isRequired,
  }).isRequired,
  errors: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    password: PropTypes.string,
    confirmPassword: PropTypes.string,
  }),
  handleChange: PropTypes.func.isRequired,
};

export default UserInfo;
